import {myStorage} from "./localStorage";
import {getPrivateOss, postBatchFileUrls} from "~/api/sever";

/**
 * 获取私有的地址
 * **/
export const queryPrivateUrl = async (url, reqTime =  3600000) => {
  // 如果是公用地址，直接返回
  if (url.includes('file2.speedtest.cn')) {
    return url;
  }
  let arr=['file3.speedtest.cn/','file4.speedtest.cn/']
  arr.forEach(item => {
    if (url.includes(item)) {
      url = url.split(item)[1];
    }
  })
  // 先从缓存中获取地址，避免多次调用接口
  let storage = new myStorage(`${url}-file2`)
  let resultPath = storage.getItem()
  let privateOssRes = resultPath;
  if (!resultPath) {
    // 调用缓存失败，则调用接口，过期时间默认是300s
    try {
      let res = await getPrivateOss({
        path: url,
        time: reqTime/1000
      })
      if (!res.code) {
        privateOssRes = res.data
        storage.setItem(privateOssRes, reqTime)
      }
    } catch (e) {
      // empty
    }
  }
  return privateOssRes;
}

export const queryPrivateUrlList = async (list,name, reqTime =  3600000) => {
  let urlList=[]
  let arr=['file3.speedtest.cn/','file4.speedtest.cn/']
  list.forEach((item,index) => {
    if(!item[name].includes('file2.speedtest.cn')){
      arr.forEach(itemC => {
        if (item[name].includes(itemC)) {
          let str=item[name].split(itemC)[1]
          item[name]=str
          urlList.push(str)
        }
      })
    }
  })
  let urlsJson=JSON.stringify(urlList)
  // 先从缓存中获取地址，避免多次调用接口
  let storage = new myStorage(`${urlsJson}-file2`)
  let resultPath = storage.getItem()
  let privateOssRes = resultPath;
  if (!resultPath) {
    // 调用缓存失败，则调用接口，过期时间默认是300s
    try {
      let res = await postBatchFileUrls({
        paths: urlList,
        time: reqTime/1000
      })
      if (!res.code) {
        privateOssRes = res.data
        storage.setItem(privateOssRes, reqTime)
      }
    } catch (e) {
      // empty
    }
  }
  list.forEach(item=>{
    if(privateOssRes[item[name]]){
      item[name]=privateOssRes[item[name]]
    }
  })
  return list;
}


